import Calendar from 'pages/calendar/Calendar';
import StackedCalendarWrapper from './StackedCalendarWrapper';
import useCalendarProperties from './propertiesList/useCalendarProperties';

const CalendarsWrapper = () => {
  const { previousPropertiesLength, previousPropertiesLimit } =
    useCalendarProperties();

  return (
    <>
      <Calendar />
      <StackedCalendarWrapper
        previousPropertiesLength={previousPropertiesLength}
        previousPropertiesLimit={previousPropertiesLimit}
      />
    </>
  );
};

export default CalendarsWrapper;
